import styled from 'styled-components';

const ModalToolbarClose = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export default ModalToolbarClose;
